module.exports = __webpack_public_path__ + "static/media/GalleryMain11.e7deaefc.jpg";